<template>
	<div class="common-share">
		<a @click="open_app()" href="ShallBuyLife123://">
    		<img class="bg" src="../../assets/register/commonShare@2x.png"/>
    		<p class="word1">好生活</p>
    		<p class="word2">就上销巴生活</p>
    		<p class="middleImg"><img src="../../assets/register/img_zjxz@2x.png"/></p>
    	</a>
	</div>
</template>

<script>
export default {
  data() {
    return {

     
    };
  },
  created(){
　　
  },
  methods: {
    open_app() {
    	if(this.$route.query.shareCode) {
    		let par = 'shareCode='+this.$route.query.shareCode+'&mobile='+this.$route.query.mobile;
	    	this.openApp('register',par,'');
    	}else {
    		this.openApp('','','');
    	}
    	
    	
    	/*<intent-filter>
		    <action android:name="android.intent.action.VIEW" />
		    <category android:name="android.intent.category.BROWSABLE" />
		    <category android:name="android.intent.category.DEFAULT"/>
		    <data
		        android:host="myapp"
		        android:scheme="app"
		        android:path="/wakeapp"
		        />
		</intent-filter>
		h5操作 链接格式例如 app://myapp/wakeapp?param=1*/
    }
  }
};
</script>

<style lang="less">
.common-share{
	height: 100%;
	background: #F2F2F2;
	.bg{
		display: block;
	    width: 100%;
	    height: 100%;
	}
	p {
    	text-align: left;
	    font-size: 30px;
	    position: absolute;
	    left: 0;
	    padding: 0;
	    margin: 0;
	    padding-left: 24%;
	}
	.word1 {
	    color: #FDE931;
	    top: 21px;
	}
	.word2 {
	    color: #FFFFFF;
	    top: 67px;
	}
	.middleImg {
	    text-align: center;
	    width: 100%;
	    top: 149px;
	    padding: 0;
	    img {
		    width: 77.6%;
		    display: inline-block;
		}
	}
}

</style>
